import { render, staticRenderFns } from "./TransactionsStatistic.vue?vue&type=template&id=348bff78&scoped=true&"
import script from "./TransactionsStatistic.vue?vue&type=script&lang=js&"
export * from "./TransactionsStatistic.vue?vue&type=script&lang=js&"
import style0 from "./TransactionsStatistic.vue?vue&type=style&index=0&id=348bff78&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "348bff78",
  null
  
)

export default component.exports